<!--
 * @FileDescription: 往来单位新增（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-01（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
      <a-modal  :title="title" class="unit-model unit-model2" v-model="isShowModel" :maskClosable="false"  @ok="onCofrimForm"  @cancel="onCancel">
          <a-form :form="form" class="unit-form">
            <div class="unit-form-left">
                <a-form-item label="单位类型" class="form-manage">
                    <a-checkbox-group v-decorator="['contactCustomerType',{rules: [{ required: true, message: '请选择单位类型' }],},]" :options="plainOptions" />
                </a-form-item>
                <a-form-item label="编号" class="form-manage">
                    <a-input placeholder="请输入编号" allow-clear  v-decorator="['code']"/>
                </a-form-item>
                <a-form-item label="单位类别">
                    <div class="manage-setting">

                        <a-select  v-decorator="['contactCustomerCategoryId',{ rules: [{ required: false}] },]"
                                   placeholder="请选择单位类别"
                                   class="tree-manage"
                        >
                            <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                            <a-select-option v-for="item in treeList" :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </div>
                </a-form-item>
                <a-form-item label="单位名称">
                    <a-input placeholder="请输入单位名称" allow-clear  v-decorator="['contactCustomerName',{rules: [{ required: true, message: '请输入单位名称' }],},]" @change="changeInput"/>
                </a-form-item>
                <a-form-item label="单位联系人">
                    <a-input placeholder="请输入单位联系人" allow-clear  v-decorator="['contactName',{rules: [{ required: true, message: '请输入单位联系人姓名' }],},]"/>
                </a-form-item>
                <a-form-item label="联系电话">
                    <a-input placeholder="请输入单位联系人联系电话" allow-clear :maxLength="16"
                             v-decorator="['mobile',{rules: [{ required: true, message: '请输入单位联系人联系电话' },],},]"/>
                </a-form-item>
                <a-form-item label="固定电话" >
                    <a-input placeholder="请输入固定电话" allow-clear  type="number" v-decorator="['telephone',{rules: [{ required: false, message: '请输入固定电话' }],},]"/>
                </a-form-item>
                <a-form-item label="传真">
                    <a-input placeholder="请输入传真" allow-clear  v-decorator="['fax',{rules: [{ required: false, message: '请输入固定电话' }],},]"/>
                </a-form-item>
            </div>
            <div class="unit-form-left">
                <a-form-item label="区域" style="padding-bottom: 5px">
                    <div class="basic-form-flex" >
                        <a-select @change="handleChangeProveice" placeholder="请选择省" class="basic-select" v-decorator="['provinceId', { rules: [{ required: false, message: '请选择省' }] }]">
                            <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                            <a-select-option v-for="item in options" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                        <a-select @change="handleChangeCity" placeholder="请选择市" :disabled="disabled"  class="basic-select"  v-decorator="['cityId', { rules: [{ required: false, message: '请选择省' }] }]">
                            <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                            <a-select-option v-for="item in options1" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                        <a-select  placeholder="请选择区" :disabled="disabled1"  class="basic-select" v-decorator="['countyId', { rules: [{ required: false, message: '请选择省' }] }]">
                            <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                            <a-select-option v-for="item in options2" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </div>
                </a-form-item>
                <a-form-item label="详细地址" >
                    <a-input placeholder="请输入详细地址" allow-clear  v-decorator="['detailAddress']"/>
                </a-form-item>
                <a-form-item label="售价设置">
                    <div class="manage-setting">

                        <a-select  v-decorator="['productPresellPriceId',{ rules: [{ required: false}] },]"
                                   placeholder="请选择售价等级"
                                   class="tree-manage"
                        >
                            <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                            <a-select-option v-for="item in priceList" :value="item.id">{{item.showName}}</a-select-option>
                        </a-select>
                    </div>
                </a-form-item>
                <a-form-item label="开户银行">
                    <a-input placeholder="请输入开户银行" allow-clear  v-decorator="['openingBank']"/>
                </a-form-item>
                <a-form-item label="银行账户" >
                    <a-input placeholder="请输入银行账户" type="number" allow-clear  v-decorator="['bankAccount']"/>
                </a-form-item>
                <a-form-item label="开户人">
                    <a-input placeholder="请输入开户人"  allow-clear  v-decorator="['bankHolder']"/>
                </a-form-item>
                <a-form-item label="备注">
                    <a-input placeholder="请输入备注信息"  v-decorator="['remark']"/>
                </a-form-item>
            </div>
        </a-form>
      </a-modal>
      <a-modal  :title="title2" class="unit-model unit-model1 " v-model="isShowModel2"  :footer="null">
          <a-table :columns="columns"
                   :dataSource="dataSource"
                   bordered
                   class="unit-address"
                   rowKey="key">
              <template slot="name" slot-scope="text, record">
                  <div class="table-name">
                      <span>{{text}}</span>
                      <img v-if="record.defaultFlag == 1" src="@/assets/image/unit_default@2x.png"/>
                  </div>
              </template>
              <template slot="areaName" slot-scope="text, record">
                    <a-tooltip>
                        <template slot="title">
                            <span>{{ text+record.detailAddress }}</span>
                        </template>
                        <span class="name-text"> {{ text+record.detailAddress }}</span>
                    </a-tooltip>
                </template>
              <template slot="operation" slot-scope="text, record">
                  <div class="operation">
                      <span @click="onOpen1(2,record)" style="margin-right: 10px;cursor:pointer;"  v-has="'system_unit_address_edit'">编辑</span>
                      <div class="operation-item"  v-has="'system_unit_address_delete'">
                          <a-popconfirm
                                  v-if="dataSource.length"
                                  title="确定删除?"
                                  @confirm="() => onDelete(record.id)"
                          >
                              <a href="javascript:;" >
                                  <img src="@/assets/image/cha_shanchu_color.png" class="operation-item-img" />
                                  <img src="@/assets/image/cha_shanchu.png" class="operation-item-img1"/>
                              </a>
                          </a-popconfirm>
                      </div>
                  </div>
              </template>
              <template slot="footer">
                  <div class="unit-footer" @click="onOpen1(1)" v-has="'system_unit_address_add'">
                      <img src="@/assets/image/add_shop_manage@2x.png"/>
                      <span>新增地址</span>
                  </div>
              </template>
          </a-table>
      </a-modal>
      <a-modal  class="unit-model3" :title="title1" :maskClosable="false"   v-model="isShowModel1"  @ok="onCofrimForm1"  @cancel="onCancel1">
          <a-form :form="form1"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 16 }"
          >
              <a-form-item label="姓名">
                  <a-input placeholder="请输入联系人姓名"
                           v-decorator="['name', { rules: [{ required: true, message: '请输入联系人' }] }]" />
              </a-form-item>
              <a-form-item label="联系电话">
                  <a-input placeholder="请输入联系电话"  :maxLength="16"
                           v-decorator="['mobile', { rules: [{ required: true, message: '请输入手机号码' },] }]" />
              </a-form-item>
              <a-form-item label="所在区域">
                  <div class="display-flex" >
                      <a-select @change="handleChangeProveice1" placeholder="请选择省" style="margin-right: 10px" v-decorator="['provinceId', { rules: [{ required: true, message: '请选择省' }] }]">
                          <a-icon slot="suffixIcon" type="caret-down"  />
                          <a-select-option v-for="item in options" :key="item.id">{{item.name}}</a-select-option>
                      </a-select>
                      <a-select @change="handleChangeCity1" placeholder="请选择市" style="margin-right: 10px" :disabled="disabled2"  v-decorator="['cityId', { rules: [{ required: true, message: '请选择市' }] }]">
                          <a-icon slot="suffixIcon" type="caret-down" />
                          <a-select-option v-for="item in options1" :key="item.id">{{item.name}}</a-select-option>
                      </a-select>
                      <a-select placeholder="请选择区" :disabled="disabled3" v-decorator="['countyId', { rules: [{ required: false, message: '请选择区' }] }]">
                          <a-icon slot="suffixIcon" type="caret-down" />
                          <a-select-option v-for="item in options2" :key="item.id">{{item.name}}</a-select-option>
                      </a-select>
                  </div>
              </a-form-item>
              <a-form-item label="详细地址">
                  <a-textarea placeholder="请输入详细的地址信息" style="min-height:60px "
                              v-decorator="['detailAddress', { rules: [{ required: true, message: '请输入详细的地址信息' }] }]" />
              </a-form-item>
              <a-form-item label="邮编">
                  <a-input placeholder="请输入邮编"
                           v-decorator="['postCode', { rules: [{ required: false, message: '请输入邮编' }] }]" />
              </a-form-item>
              <a-form-item label=" ">
                  <a-checkbox @change="onChangeDefault"  :checked="isCheck" v-decorator="['defaultFlag', { rules: [{ required: false, message: '请输入邮编' }] }]">设为默认</a-checkbox>
              </a-form-item>
          </a-form>
      </a-modal>
  </div>
</template>
<script>
import {arealist,conditionAdd,conditionUpdate,customerList,customerAdd,customerUpdate,customerDelete,priceList} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import ATextarea from "ant-design-vue/es/input/TextArea";
import pick from 'lodash.pick'
export default {
    mixins:[mixins],
    props:{
        treeList:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
            title:'新增往来单位',
            isShowModel:false,
            title2:'收货地址',
            isShowModel2:false,
            title1:'新增收货地址',
            isShowModel1:false,
            form: this.$form.createForm(this),
            form1: this.$form.createForm(this),
            plainOptions:[
                {
                    value:'1',
                    label:'供应商'
                },
                {
                    value:'0',
                    label:'客户'
                }
            ],
            disabled:true,
            disabled1:true,
            disabled2:true,
            disabled3:true,
            columns: [
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    width:100,
                    align: 'center',
                    scopedSlots: { customRender: 'name' },
                },
                {
                    title: '联系电话',
                    width:150,
                    dataIndex: 'mobile',
                    key: 'mobile',
                },
                {
                    title: '详细地址',
                    dataIndex: 'areaName',
                    width:300,
                    key: 'areaName',
                    scopedSlots: { customRender: 'areaName' },
                },
                {
                    title: '操作',
                    width:110,
                    scopedSlots: { customRender: 'operation' },
                },

            ],
            dataSource: [],
            isCheck:false,
            options:[],
            options1:[],
            options2:[],
            model:{},
            model1:{},
            priceList:[]
        }
    },
    watch: {
    },
    mounted () {
        this.getPriceList('',1)
        this.getpriceListSelect()
    },
    created () {

    },
    components: {
        ATextarea


    },
    methods: {
        /**
         * @description: 获取售价信息列表（方法描述）
         */
        getpriceListSelect(){
            let data = new FormData()
            data.append('companyStoreId',this.$store.state.shopId)
            priceList(data,{
                'Content-Type':'application/json'
            }).then((res)=>{
                if(res.success){
                    this.priceList = res.result
                }
            })
        },
        /**
         * @description: 区域（方法描述）
         */
        getPriceList(values,index){
            let data = {
                parentId:values
            }
            data =   this.$qs.stringify(data)
            arealist(data,{}).then((res)=>{
                if(res.success){
                    res.result.forEach((item)=>{
                        item.label = item.name
                        item.value = item.id
                    })
                    if(index == 1){
                        this.options = res.result
                    }else if(index == 2){
                        this.options1 = res.result
                    }else if(index == 3){
                        this.options2 = res.result
                    }
                }
            })
        },
        //单位名称
        changeInput(event){
            this.$nextTick(() => {
                this.form.setFieldsValue({
                    contactName:event.target.value
                })
            });
        },
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onCofrimForm(){
            this.form.validateFields((err, values) => {
                if(!err){
                    console.log(values)
                    values.contactCustomerType = values.contactCustomerType.join(',')
                    if(values.contactCustomerType.length > 1){
                        values.contactCustomerType.substring(0,values.contactCustomerType.length - 1 )
                    }
                    values.companyStoreId = this.$store.state.shopId
                    values.companyId = this.$store.state.companyId
                    // values.code = this.model.code
                    if(this.isEmpty(this.model.id)){
                        conditionAdd(values,{}).then((res)=>{
                            if(res.success){
                                this.isShowModel = false
                                this.$emit('onPageList')
                                this.$message.success(res.logMessage)
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }else{
                        values.id = this.model.id
                        conditionUpdate(values,{}).then((res)=>{
                            if(res.success){
                                this.isShowModel = false
                                this.$emit('onPageList')
                                this.$message.success(res.logMessage)
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }
                }
            })
        },
        onCancel(){
            this.isShowModel = false
            this.isShowModel2 = false
        },
        onOpen(index,record){
            this.model = {}
            if(index == 1){
                record.contactCustomerType = ['0','1']
                this.form = this.$form.createForm(this)
                this.model = Object.assign({},record)
                this.isShowModel = true
                this.title = '新增往来单位'
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model,'contactCustomerType'))
                });
                this.disabled = true
                this.disabled1 = true
            }else if(index ==2){
                this.model = Object.assign({},record)
                let contactCustomerType = this.model.contactCustomerType
                contactCustomerType =  (contactCustomerType +',').split(',')
                if(contactCustomerType[contactCustomerType.length] == ''){
                    contactCustomerType.pop()
                }
                this.model.contactCustomerType = contactCustomerType
                this.form = this.$form.createForm(this)
                this.isShowModel = true
                this.title = '编辑往来单位'
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model,'contactCustomerType','code','bankAccount','bankHolder','categoryName','cityId','contactCustomerCategoryId','id','productPresellPriceId',
                            'contactName','contactCustomerName','countyId','detailAddress','fax','mobile','openingBank','provinceId','remark','telephone'))
                    this.getPriceList(this.model.provinceId,2)
                    this.getPriceList(this.model.cityId,3)
                });
                this.disabled = false
                this.disabled1 = false
            }else if(index == 3){
                this.model = record
                let data = {contactCustomerId:record.id}
                data =   this.$qs.stringify(data)
                customerList(data,{}).then((res)=>{
                    if(res.success){
                        this.isShowModel2 = true
                        this.dataSource = res.result
                    }
                })
            }
        },
        onCofrimForm1(){
            this.form1.validateFields((err, values) => {
                if(!err){
                    values.contactCustomerId = this.model.id
                    if(this.isCheck){
                        values.defaultFlag = 1
                    }else{
                        values.defaultFlag = 0
                    }
                    values.companyStoreId = this.$store.state.shopId
                    if(!this.isEmpty(this.model1.id)){
                        values.id = this.model1.id
                        customerUpdate(values,{}).then((res)=>{
                            if(res.success){
                                this.onOpen(3,this.model)
                                this.$message.success(res.logMessage)
                                this.onCancel1()
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }else{
                        customerAdd(values,{}).then((res)=>{
                            if(res.success){
                                this.onOpen(3,this.model)
                                this.$message.success(res.logMessage)
                                this.onCancel1()
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }
                }
            })
        },
        onCancel1(){
            this.isShowModel1 = false
        },
        onOpen1(index,record){
            this.model1  = {}
            if(index == 1){
                this.form1 = this.$form.createForm(this)
                this.title1 = '新增收货地址'
                this.isCheck = false
                this.disabled2 = true
                this.disabled3 = true
            }else{
                if(record.defaultFlag == '1'){
                    this.isCheck = true
                }else{
                    this.isCheck = false
                }
                this.model1 = Object.assign({},record)
                this.form1 = this.$form.createForm(this)
                this.title2 = '编辑收货地址'
                this.$nextTick(() => {
                    this.form1.setFieldsValue(pick(this.model1,'cityId','contactName','countyId','detailAddress','mobile','contactCustomerId',
                                                'name','postCode','provinceId',
                         ))
                    this.getPriceList(this.model1.provinceId,2)
                    this.getPriceList(this.model1.cityId,3)
                });
                this.disabled2 = false
                this.disabled3 = false
            }
            this.isShowModel1 = true
        },
        /**
         * @description: 所在区域省（方法描述）
         */
        handleChangeProveice(e){
            this.$nextTick(()=>{
                this.form.setFieldsValue({
                    cityId:undefined,
                    countyId:undefined
                })
            })
            this.getPriceList(e,2)
            this.disabled = false
            this.disabled1 = true
        },
        /**
         * @description: 所在区域市（方法描述）
         */
        handleChangeCity(e){
            this.$nextTick(()=>{
                this.form.setFieldsValue({
                    countyId:undefined
                })
            })
            this.getPriceList(e,3)
            this.disabled1 = false
        },
        /**
         * @description: 所在区域省（方法描述）
         */
        handleChangeProveice1(e){
            this.$nextTick(()=>{
                this.form1.setFieldsValue({
                    cityId:undefined,
                    countyId:undefined
                })
            })
            this.getPriceList(e,2)
            this.disabled2 = false
            this.disabled3 = true
        },
        /**
         * @description: 所在区域市（方法描述）
         */
        handleChangeCity1(e){
            this.$nextTick(()=>{
                this.form1.setFieldsValue({
                    countyId:undefined
                })
            })
            this.getPriceList(e,3)
            this.disabled3 = false
        },
        /**
         * @description: 默认地址（方法描述）
         */
        onChangeDefault(e){
            console.log(e.target.checked)
            this.isCheck = e.target.checked
        },
        onDelete(id){
            let data = {
                id:id,
                companyStoreId:this.$store.state.shopId,
            }
            data = this.$qs.stringify(data)
            customerDelete(data,{}).then((res)=>{
                if(res.success){
                    this.onOpen(3,this.model)
                    this.$message.success(res.logMessage)
                }else{
                    this.$message.warn(res.logMessage)
                }
            })
        }
    },

}
</script>
<style lang="scss">
    .unit-model1{
        width: 840px !important;
    }
    .unit-model2{
        width: 900px !important;
        height: 1050px !important;
    }
    .unit-model3{
        width: 680px !important;
        height: 660px !important;
    }
    .unit-model{
        .ant-modal-body{
            height: calc(100% - 170px);
            padding: 10px 40px 30px;
            .unit-form{
                padding: 0 40px;
            }
            .basic-form-flex{
                display: flex;

                .basic-select{
                    margin-right: 6px;
                    width: 110px;
                }
                .basic-select:last-child{
                    margin-right: 0;
                }
            }
            .setting-img{
                margin-left: 8px;
            }
        }
        .ant-pagination{
            display: none;
        }
        .table-name{
            position: relative;
            img{
                position: absolute;
                top: -16px;
                left: -15px;
                width: 46px;
            }
        }
        .unit-footer{
            cursor: pointer;
            width: 100px;
            display: flex;
            align-items: center;
            color: #387BFC;
            padding-top: 20px;
            img{
                width: 16px;
                margin-right: 7px;
            }
        }
    }
    .unit-address{
        .ant-table-footer{
            border-top:1px solid #f0f0f0 !important;
        }
    }
</style>
<style scoped lang="scss">
.unit-form{
    display: flex;
    .unit-form-left{
        flex: 1;
        margin-right: 70px;
    }
    .unit-form-left:last-child{
        margin-right: 0;
    }
    .form-manage{
        .ant-form-item-label > label::after{
            content:'(可多选)'!important;
            color: #888888;
            font-size: 14px;
        }
    }
}
.operation{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #387BFC;
}
</style>
